export const SCAN_SITE_KEY = 'scanSite';
export const SEGMENT_TYPES_KEY = 'segmentTypes';
export const SCAN_PATTERN_KEY = 'scanPattern';
export const LAST_SYNC_TIMESTAMP_KEY = 'lastSyncTimestamp';
export const PENDING_UPLOAD_TIMESTAMP_KEY = 'pendingUploadTimestamp';
